/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';
import { Box, useTheme, BoxProps } from '@mui/material';
import { useDevices } from '../hooks';

interface HoverAddUnderLineProps extends BoxProps {
  lineColor?: string;
  lineSx?: BoxProps['sx'];
}

export const HoverAddUnderLine = forwardRef(
  (
    { children, sx, lineColor, lineSx, ...attrs }: HoverAddUnderLineProps,
    ref: any,
  ) => {
    const theme = useTheme();
    const { isMobile } = useDevices();

    const hoverCss = isMobile
      ? {}
      : {
          '&:hover': {
            '.hover-under-line': {
              display: 'block',
            },
          },
        };

    return (
      <Box
        ref={ref}
        sx={{
          position: 'relative',
          '.hover-under-line': {
            display: 'none',
          },
          ...hoverCss,
          ...sx,
        }}
        {...attrs}
      >
        {children}
        <Box
          className="hover-under-line"
          sx={{
            width: '100%',
            height: '1px',
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: -3,
            backgroundColor: lineColor || theme.palette.text.primary,
            ...lineSx,
          }}
        />
      </Box>
    );
  },
);
